export const EXPERIMENT_KEY = 'ab_test';
